import DefaultChipCard from './DefaultChipCard';

export default DefaultChipCard;
